import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const CLAUDE_ICON_SRC = `${process.env.PUBLIC_URL}/claude.png`;

/**
 * Themed PrecisionAI mark from public/claude.png (monochrome).
 * Active: theme primary purple; inactive: textMuted grey (matches nav icons).
 */
const PrecisionAIIcon = ({
  size = 23,
  active = false,
  color,
  className,
  style,
  title = 'PrecisionAI',
}) => {
  const { colors } = useTheme();
  const fill = color ?? (active ? colors.primary : colors.textMuted);

  return (
    <span
      role="img"
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        flexShrink: 0,
        width: size,
        height: size,
        backgroundColor: fill,
        WebkitMaskImage: `url(${CLAUDE_ICON_SRC})`,
        maskImage: `url(${CLAUDE_ICON_SRC})`,
        WebkitMaskSize: '117%',
        maskSize: '117%',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        ...style,
      }}
    />
  );
};

export default PrecisionAIIcon;
